export const SET_MAINTENANCE_RESPONSE = 'SET_MAINTENANCE_RESPONSE';

/** @namespace Pwa/Store/Maintenance/Action/setMaintenanceResponse */
export const setMaintenanceResponse = (data) => ({
    type: SET_MAINTENANCE_RESPONSE,
    data
});
